import React, { Fragment, useEffect } from "react";
import Room from "./Room";
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles';
import { useWidgetContext } from "../widgetContext";
import BookingPickersWrapper from "./BookingPickersWrapper"
import Api from '../Api';
import BackButton from "./BackButton";
import NoSearchResults from "./NoSearchResults";
import { GetResourceVenueId, GetAdjustedDate } from '@switch/core';

const useStyles = makeStyles(theme => ({
    lowerContent: {
        maxWidth: '574px'
    }
}));

const RoomsList = ({ rooms, addBookingDetail }) => {
    const classes = useStyles();
    const context = useWidgetContext();
    const [ResourceAvailability, setResourceAvailability] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const occasionId = context.bookingRequest.occasionId;
    const bookingDate = GetAdjustedDate(context.bookingRequest.bookingDate);

    useEffect(() => {
        setResourceAvailability([])
    }, [context.bookingRequest.bookingDate]);


    useEffect(() => {
        if (loading) return;
        if (!context.bookingRequest?.startTime || !context.bookingRequest?.endTime) return;  // Still setting up request
        if (rooms?.length > 0 && ResourceAvailability && (ResourceAvailability?.length === 0 || GetAdjustedDate(ResourceAvailability[0]?.date) !== GetAdjustedDate(bookingDate))) {
            getResourceAvailability()
        }
    }, [rooms, ResourceAvailability, bookingDate]);


    if (!rooms) return null;

    const API = new Api(
        {
            urlRoot: window.location.origin + "/Dispace/Switch/1.0.0/BookingRequest/",
            //urlRoot: "https://switchdev.azurewebsites.net/Dispace/Switch/1.0.0/BookingRequest/"
            widgetKey: context.widgetKey
        });

    function getResourceAvailability() {
        const sourceKey = context.widgetKey;
        const startDate = GetAdjustedDate(context.bookingRequest.bookingDate)
        const endDate = GetAdjustedDate(context.bookingRequest.bookingEndDate)
        let resourceString;
        {
            rooms.map(room => {
                if (resourceString === undefined) {
                    resourceString = '&resourceId=' + room.id;
                } else {
                    resourceString = resourceString + '&resourceId=' + room.id;
                }
            })
        }

        const venueId = GetResourceVenueId(rooms[0], context?.bookingRequest?.venueId)

        const queryString = '?venueid=' + venueId + resourceString + '&startDate=' + startDate.substring(0, 19) + '&endDate=' + endDate.substring(0, 19) + '&occasionid=' + occasionId;
        setLoading(true)
        API.getResourceAvailability(sourceKey, queryString, context.bookingRequest).then((result) => {
            setResourceAvailability(result);
            setLoading(false)
        });
    }



    return (
        <Grid container direction="row" justify="center" alignItems="center" spacing={4}>
            <BookingPickersWrapper matUiXl="12" />
            <BackButton matUiXl="0" margin="0px" />
            {rooms.length === 0 ?
                <NoSearchResults title={"switch.widget.notfound.norooms"} classes={classes} />
                :
                <Fragment>
                    {rooms.map(item => {
                        return (
                            <Grid item xs={12} key={item.id} className={!context.showAvailabilityCalendar && classes.lowerContent}>
                                <Room key={item.id} room={item} addBookingDetail={addBookingDetail} context={context} resourceAvailability={ResourceAvailability} />
                            </Grid>
                        );
                    })}
                </Fragment>
            }
        </Grid>
    );
};

export default RoomsList;
